import React from "react";
import { Container, Image, H2, P, Button } from "./SideStyle";
import { Link } from "react-router-dom";
import { Label } from "semantic-ui-react";

const welcome = "../../../assets/images/headphone.png";

const SideComponent = ({ register, text, widths, margin }) => {
  return (
    <Container widths={widths} margin={margin} className='container'>
      <Image>
        <img src={welcome} alt='welcome' />
      </Image>
      <H2>Welcome To Music App</H2>
      <Link to='/'>
        <Label style={{ marginBottom: "10px" }}>Home</Label>
      </Link>
      <P>
        If your yet to signup for some awesome package hit the register button
        below
      </P>
      <Link className='link' to={`/${register}`}>
        <Button>{text}</Button>
      </Link>
    </Container>
  );
};

export default SideComponent;
